import React from 'react';
import TextField from '@mui/material/TextField';

const CustomDateInput = React.forwardRef((props, ref) => {
  return (
    <TextField
      {...props}
      inputRef={ref}
      variant="outlined"
      fullWidth
      margin="normal"
      sx={{
        '& .MuiOutlinedInput-input': {
          fontSize: '16px',

          padding: '16.5px 14px',

          boxSizing: 'content-box !important',
          border: 'none !important',
        },

        '& .MuiOutlinedInput-notchedOutline': {
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#333333',
            borderWidth: '1px',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#1976d2',
            borderWidth: '2px',
          },

          '& .MuiInputLabel-outlined': {
            backgroundColor: '#fff',
            padding: '0 6px',
            transform: 'translate(14px, -8px) scale(0.75)',
          },
        },
      }}
    />
  );
});

CustomDateInput.displayName = 'CustomDateInput';

export default CustomDateInput;
